'use strict';

var PromiseRetryService = function PromiseRetryService($timeout) {
  var retryWrapper = function retryWrapper(fn, config) {
    var success = config.success;
    var validate = config.validate;
    var error = config.error;
    var retryLimit = config.retryLimit || 10;
    var delay = config.delay || 1000;
    var increment = config.increment || 0;
    var count = 0;
    var _tryAgain = function tryAgain() {
      fn().then(success, function () {
        if (validate.apply(null, arguments)) {
          count++;
          if (count >= retryLimit) {
            return error.apply(null, arguments);
          }
          $timeout(function () {
            _tryAgain();
          }, delay);
          delay += increment;
        } else {
          error.apply(null, arguments);
        }
      });
    };
    _tryAgain();
  };
  return {
    retry: retryWrapper
  };
};
PromiseRetryService.$inject = ['$timeout'];
module.exports = PromiseRetryService;